<template>
	<v-card flat outlined>
		<v-card-text class="pb-4 pt-0">
			<v-row>
				<v-flex lg5 xs12 sm12 class="pa-0">
					<TeachersOnCourse :plannedCourseId="plannedCourseId"></TeachersOnCourse>
				</v-flex>
				<v-flex lg7 xs12 sm12 class="pa-0">
					<TeacherActivities :plannedCourseId="plannedCourseId" :canEdit="canEdit"></TeacherActivities>
				</v-flex>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
import TeachersOnCourse from './TeachersOnCourse';
import TeacherActivities from './TeacherActivities';

export default {
	name: 'Teachers',
	components: { TeachersOnCourse, TeacherActivities },
	props: {
		plannedCourseId: [String, Number],
		canEdit: Boolean,
	},
	data() {
		return {};
	},
};
</script>

<style scoped></style>
